// extracted by mini-css-extract-plugin
module.exports = {"container":"i_C6","checked":"i_C7","dark":"i_C8","light":"i_C9","label":"i_DA","icon":"i_DB"};